import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      title: 'Chinese Name Generator',
      subtitle: 'Generate a meaningful Chinese name that reflects traditional culture',
      inputPlaceholder: 'Enter your name',
      generate: 'Generate Name',
      random: 'Random Name',
      loading: 'Generating...',
      generating: 'Generating',
      generatingRandom: 'Generating Random Name',
      yourChineseName: 'Your Chinese Name',
      contact: 'Free to use. Any suggestions?',
      xiaohongshu: 'My Xiaohongshu',
      generateCard: 'Generate Card',
      downloadImage: 'Download Image',
      regenerateName: 'Try Another Name',
      pleaseEnterName: 'Please enter your name first'
    }
  },
  zh: {
    translation: {
      title: '汉字姓名生成器',
      subtitle: '生成一个富有传统文化内涵的汉字姓名',
      inputPlaceholder: '输入你的名字',
      generate: '生成姓名',
      random: '随机生成',
      loading: '生成中...',
      generating: '正在生成',
      generatingRandom: '正在随机生成',
      yourChineseName: '你的汉字姓名',
      contact: '应用免费使用，有建议吗？',
      xiaohongshu: '我的小红书',
      generateCard: '生成卡片',
      downloadImage: '下载图片',
      regenerateName: '换个名字',
      pleaseEnterName: '请先输入你的名字'
    }
  },
  ja: {
    translation: {
      title: '漢字名前ジェネレーター',
      subtitle: '伝統文化を反映した意味のある漢字名前を生成します',
      inputPlaceholder: 'お名前を入力',
      generate: '名前を生成',
      random: 'ランダム生成',
      loading: '生成中...',
      generating: '生成中',
      generatingRandom: 'ランダム生成中',
      yourChineseName: 'あなたの漢字名前',
      contact: '無料でご利用いただけます。ご提案はありますか？',
      xiaohongshu: '私のXiaohongshu',
      generateCard: 'カードを生成',
      downloadImage: '画像をダウンロード',
      regenerateName: '別の名前を試す',
      pleaseEnterName: 'お名前を入力してください'
    }
  },
  ko: {
    translation: {
      title: '한자 이름 생성기',
      subtitle: '전통 문화를 반영하는 의미 있는 한자 이름을 생성합니다',
      inputPlaceholder: '이름을 입력하세요',
      generate: '이름 생성',
      random: '무작위 생성',
      loading: '생성 중...',
      generating: '생성 중',
      generatingRandom: '무작위 생성 중',
      yourChineseName: '당신의 한자 이름',
      contact: '무료로 사용할 수 있습니다. 제안이 있으신가요?',
      xiaohongshu: '나의 샤오홍슈',
      generateCard: '카드 생성',
      downloadImage: '이미지 다운로드',
      regenerateName: '다른 이름 시도',
      pleaseEnterName: '이름을 먼저 입력해주세요'
    }
  },
  de: {
    translation: {
      title: 'Chinesischer Namensgenerator',
      subtitle: 'Generieren Sie einen bedeutungsvollen chinesischen Namen, der die traditionelle Kultur widerspiegelt',
      inputPlaceholder: 'Geben Sie Ihren Namen ein',
      generate: 'Namen generieren',
      random: 'Zufälliger Name',
      loading: 'Generiere...',
      generating: 'Generiere',
      generatingRandom: 'Generiere zufälligen Namen',
      yourChineseName: 'Ihr chinesischer Name',
      contact: 'Kostenlos nutzbar. Haben Sie Vorschläge?',
      xiaohongshu: 'Mein Xiaohongshu',
      generateCard: 'Karte generieren',
      downloadImage: 'Bild herunterladen',
      regenerateName: 'Anderen Namen probieren',
      pleaseEnterName: 'Bitte geben Sie zuerst Ihren Namen ein'
    }
  },
  fr: {
    translation: {
      title: 'Générateur de noms chinois',
      subtitle: 'Générez un nom chinois significatif qui reflète la culture traditionnelle',
      inputPlaceholder: 'Entrez votre nom',
      generate: 'Générer un nom',
      random: 'Nom aléatoire',
      loading: 'Génération...',
      generating: 'Génération',
      generatingRandom: 'Génération de nom aléatoire',
      yourChineseName: 'Votre nom chinois',
      contact: 'Gratuit. Des suggestions ?',
      xiaohongshu: 'Mon Xiaohongshu',
      generateCard: 'Générer une carte',
      downloadImage: 'Télécharger l\'image',
      regenerateName: 'Essayer un autre nom',
      pleaseEnterName: 'Veuillez d\'abord entrer votre nom'
    }
  },
  ar: {
    translation: {
      title: 'مولد الأسماء الصينية',
      subtitle: 'قم بإنشاء اسم صيني ذو معنى يعكس الثقافة التقليدية',
      inputPlaceholder: 'أدخل اسمك',
      generate: 'توليد اسم',
      random: 'اسم عشوائي',
      loading: 'جاري التوليد...',
      generating: 'جاري التوليد',
      generatingRandom: 'جاري التوليد العشوائي',
      yourChineseName: 'اسمك الصيني',
      contact: 'مجاني للاستخدام. هل لديك اقتراحات؟',
      xiaohongshu: 'شياوهونغشو الخاص بي',
      generateCard: 'إنشاء بطاقة',
      downloadImage: 'تحميل الصورة',
      regenerateName: 'جرب اسمًا آخر',
      pleaseEnterName: 'الرجاء إدخال اسمك أولاً'
    }
  },
  ru: {
    translation: {
      title: 'Генератор китайских имен',
      subtitle: 'Создайте значимое китайское имя, отражающее традиционную культуру',
      inputPlaceholder: 'Введите ваше имя',
      generate: 'Сгенерировать имя',
      random: 'Случайное имя',
      loading: 'Генерация...',
      generating: 'Генерация',
      generatingRandom: 'Генерация случайного имени',
      yourChineseName: 'Ваше китайское имя',
      contact: 'Бесплатно. Есть предложения?',
      xiaohongshu: 'Мой Xiaohongshu',
      generateCard: 'Создать карточку',
      downloadImage: 'Скачать изображение',
      regenerateName: 'Попробовать другое имя',
      pleaseEnterName: 'Пожалуйста, сначала введите ваше имя'
    }
  },
  es: {
    translation: {
      title: 'Generador de nombres chinos',
      subtitle: 'Genera un nombre chino significativo que refleje la cultura tradicional',
      inputPlaceholder: 'Ingresa tu nombre',
      generate: 'Generar nombre',
      random: 'Nombre aleatorio',
      loading: 'Generando...',
      generating: 'Generando',
      generatingRandom: 'Generando nombre aleatorio',
      yourChineseName: 'Tu nombre chino',
      contact: 'Uso gratuito. ¿Tienes sugerencias?',
      xiaohongshu: 'Mi Xiaohongshu',
      generateCard: 'Generar tarjeta',
      downloadImage: 'Descargar imagen',
      regenerateName: 'Probar otro nombre',
      pleaseEnterName: 'Por favor, ingresa tu nombre primero'
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['querystring', 'cookie', 'navigator'],
      caches: ['cookie'],
      cookieMinutes: 60 * 24 * 7,
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      convertLanguageByLowerCase: true
    }
  });

export default i18n;
